"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatBankTable = void 0;
const formatBankTable = (bankDetails, customerDetails, amount, currency, translationsKeys) => {
    const highlight = true;
    return [
        { label: translationsKeys.amountText, value: `${currency.toUpperCase()} ${amount}` },
        { label: translationsKeys.senderNameText, value: `${customerDetails.tradingAccount} ${customerDetails.accountIdentificationCode}`, highlight },
        { label: translationsKeys.accountNameText, value: bankDetails.bankAccountName },
        { label: translationsKeys.bankText, value: bankDetails.bankName, highlight },
        { label: translationsKeys.branchText, value: bankDetails.bankBranch },
        { label: translationsKeys.branchCodeText, value: bankDetails.branchCode },
        { label: translationsKeys.accountNoText, value: bankDetails.accountNumber, highlight },
    ];
};
exports.formatBankTable = formatBankTable;
